import React, { useEffect, useMemo, useState } from 'react';
import Separator from '../../../../../components/Separator/Separator';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import CustomRadioGroup from '../../../../../components/CustomRadioGroup/CustomRadioGroup';

const VisionAcuityInCloseDistance = ({ data, control, setValue }) => {
  const { t } = useTranslation();
  const [bValue, setBValue] = useState(data?.visionAcuityInCloseDistance?.b);

  const values = useMemo(
    () => [
      {
        label: t('yes'),
        checked: bValue === true,
        value: true,
      },
      {
        label: t('no'),
        checked: bValue === false,
        value: false,
      },
    ],
    [bValue]
  );

  
  useEffect(() => {
    setValue('visionAcuityInCloseDistance.b', data?.visionAcuityInCloseDistance?.b);
  }, []);

  return (
    <>
      <Separator text={t('examinations:screenings.visionAcuityInCloseDistance.title')} hint={t('examinations:screenings.visionAcuityInCloseDistance.hint')}/>
      <Row>
        <Col md={6}>
          <h5>{t('examinations:bothEyes')}</h5>
          <CustomRadioGroup
            label={t('examinations:screenings.visionAcuityInCloseDistance.identifiesImages')}
            labelClass="d-block"
            items={values}
            groupProps={{ className: 'mb-3' }}
            controlProps={{
              name: 'visionAcuityInCloseDistance.b',
              control,
              rules: { validate: v => v !== undefined || 'required' },
              defaultValue: data?.visionAcuityInCloseDistance?.b,
            }}
            onChange={v => {
              setBValue(v);
              setValue('visionAcuityInCloseDistance.b', v);
            }}
          />
        </Col>
      </Row>
    </>
  );
};
export default VisionAcuityInCloseDistance;
